import { render } from "./DialogForm.vue?vue&type=template&id=082ec0e4&scoped=true"
import script from "./DialogForm.vue?vue&type=script&lang=js"
export * from "./DialogForm.vue?vue&type=script&lang=js"

import "./DialogForm.vue?vue&type=style&index=0&id=082ec0e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082ec0e4"]])

export default __exports__